export const formattedTitle = (value: string) => {
  const title = value.charAt(0).toUpperCase() + value.slice(1);
  return title.split(/(?=[A-Z])/).join(" ");
};
